//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import React from 'react';
import styled from 'styled-components';

import { FileUploadProgress } from '@content-drawer/upload/FileUploadProgress';
import { useUploader } from '@content-drawer/upload/useUploader';

export const UploadStatus = () => {
  const { cancelUpload, uploads } = useUploader();

  return (
    <Wrapper>
      {uploads
        .filter((upload) => !upload.completed)
        .map((upload) => (
          <FileUploadProgress
            key={upload.id}
            onCancel={cancelUpload}
            upload={upload}
          />
        ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
